import { render, staticRenderFns } from "./cooper-user.vue?vue&type=template&id=90c46856&scoped=true"
import script from "./cooper-user.vue?vue&type=script&lang=js"
export * from "./cooper-user.vue?vue&type=script&lang=js"
import style0 from "./cooper-user.vue?vue&type=style&index=0&id=90c46856&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90c46856",
  null
  
)

export default component.exports